// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appLinkBaseUrl: "https://dev.applink.communoplus.com",
  firebaseConfig: {
    apiKey: "AIzaSyA8DRe3ac8nOCCoHtpjGgJWq7JYPdj1ZVE",
    authDomain: "communoplus-dev-0.firebaseapp.com",
    projectId: "communoplus-dev-0",
    storageBucket: "communoplus-dev-0.firebasestorage.app",
    messagingSenderId: "377455767278",
    appId: "1:377455767278:web:ee8759ca9aa589ce30cdff",
    measurementId: "G-F8E2Q42HS9"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
